import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";

const CountryList = (props: any) => {
  const { handleIsActive } = props
  const defaultColumns: any = [
   
    {
      header: "S.N",
      accessorKey: ".",
      cell: ({ row }: any) => <>{row?.index + 1}</>,
    },
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Total State",
      accessorKey: "total_state",
      cell: NACell,
    },
    {
      header: "Total District",
      accessorKey: "total_district",
      cell: NACell,
    },
    {
      header: "Total City",
      accessorKey: "total_city",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />
      )
    },
    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`edit/${getValue()}`} />
        </>
      ),
    },
  ];
  return (
    <DataTable
      url={APIS.LOCATION}
      queryKey={"country"}
      columns={defaultColumns}
      params={{ level: 0 }}
      addNewPagePath={"/create-country"}
      tableName={"Country"}
    />
  );
};

export default CountryList;
